module.exports = __webpack_public_path__ + "assets/images/6fb25dd65a66b64cdea1ade3c1fe6347.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/icons/linkedin.svg
// module id = 730
// module chunks = 0